<template>
  <div class="w-full">
    <div :class="showSearch ? 'flex items-center gap-2' : 'hidden'">
      <PrimeInputText
        v-model="search"
        ref="searchBox"
        placeholder="Search..."
        class="h-10 text-lg flex-1"
        @keydown="handleKeydown"
      />
      <button
        @click="clearSearch"
        class="text-gray-400 hover:text-red-500 hover:scale-110 transition-all duration-200"
      >
        <i class="pi pi-times text-lg" />
      </button>
    </div>
    <button
      :class="showSearch ? 'hidden' : 'flex'"
      @click="activateSearch"
      ref="searchIcon"
      class="items-center gap-3 px-3 py-2 text-white rounded-md transition-all duration-200 hover:bg-white/10 hover:text-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50 w-full"
    >
      <i class="pi pi-search text-xl" aria-hidden="true"></i>
      <span class="font-medium">
        Search <span class="ml-1 text-sm text-gray-400 italic">(Ctrl + /)</span>
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
const search = defineModel<string>("search", {
  default: "",
});
const showSearch = ref<boolean>(false);
const searchBox = ref();
const searchIcon = ref();

function activateSearch() {
  showSearch.value = true;
  if (search.value) search.value = "";
  nextTick(() => {
    searchBox.value?.$el?.focus();
  });
}

function clearSearch() {
  search.value = "";
  showSearch.value = false;
  nextTick(() => {
    searchIcon.value?.focus();
  });
}

function handleKeydown(event: any) {
  if (event.key === "Escape") {
    clearSearch();
  }
}

// Activate search if user presses '/' key
if (import.meta.client) {
  window.addEventListener("keydown", (event) => {
    if (event.key === "/" && event.ctrlKey === true) {
      event.preventDefault();
      activateSearch();
    }
  });
}
</script>

<style scoped></style>
